import { render, staticRenderFns } from "./PrivacyScanRay.vue?vue&type=template&id=31903cd5&scoped=true"
import script from "./PrivacyScanRay.vue?vue&type=script&lang=js"
export * from "./PrivacyScanRay.vue?vue&type=script&lang=js"
import style0 from "./PrivacyScanRay.vue?vue&type=style&index=0&id=31903cd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31903cd5",
  null
  
)

export default component.exports